<template>
  <ApplicationLayout
    :user="user"
    :options="options"
    :version="version"
    :links="links"
    :showActionItems="true"
  >
    <!-- Set System bar content if enabled-->
    <template #systembar></template>

    <!-- Set Appbar title-->
    <template #title>
      <v-toolbar-title class="font-weight-bold d-flex">
        PD Calculator - {{ getTitle() }}
      </v-toolbar-title>
      <v-icon small style="margin-top: -20px">mdi-apps</v-icon>
    </template>

    <!-- Use to add addition items to Appbar -->
    <template #toolbar>
      <ReportIssueButton />
    </template>

    <!-- Use change Navbar header content-->
    <template #navheader></template>

    <!-- Use display content-->
    <template #content>
      <router-view :key="$route.fullPath"/>
    </template>
  </ApplicationLayout>
</template>

<script>
import ApplicationLayout
  from '@/modules/shared/components/core/layouts/ApplicationLayout.vue';
import CoreMixin from '@/mixins/core.mixin';
import PDMixin from '@/modules/pd/common/pd.mixin';
import ReportIssueButton from '@/modules/shared/components/core/ReportIssueButton.vue';

const layoutOptions = {
  showSystemBar: false,
  showSearchBar: false,
  showUserOptions: true,
  showMenuToggle: true,
  appBarColor: '#fafbfc',
  miniDrawerColor: '',
  miniDrawerIconsColor: 'white',
  leftDrawerColor: 'white',
  leftDrawerIconsColor: ''
};

export default {
  components: { ApplicationLayout, ReportIssueButton },
  mixins: [CoreMixin, PDMixin],
  data: () => ({
    options: layoutOptions,
    links: [
      {
        title: 'Dashboard',
        icon: 'mdi-chart-line',
        to: '/pd/dashboard'
      },
      {
        title: 'Reports',
        icon: 'mdi-file-document',
        to: '/pd/reports'
      }
    ],
  }),

  mounted() {
    if(this.checkAuth('View File Uploads')) {
      this.links.push({
        title: 'Upload Center',
        icon: 'mdi-upload',
        to: '/pd/uploads'
      });
    }

    if(this.checkAuth('View Settings')) {
      this.links.push({
        title: 'Settings',
        icon: 'mdi-cogs',
        to: '/pd/settings'
      });
    }
  },

  methods: {
    getTitle() {
      switch(this.$route.name) {
        case "pd-dashboard":
          return "Dashboard";
        case "pd-reports":
          return "Report Center";
        case "pd-report-details":
          return "Report Details";
        case "pd-uploads":
          return "Upload Center";
        case "pd-settings":
          return "Settings";
        default:
          return "Unknown";
      }
    },
  }

};
</script>